import React, { useState } from 'react';

import { copyToClipboard } from 'utils/browser';
import Button from '@mui/material/Button';
import intl from 'react-intl-universal';
import logger from 'utils/logger';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';
const log = logger.createLogger('CopyLinkButton');

const propTypes = {
  serviceType: PropTypes.string.isRequired,
};

const CopyLinkButton = ({ serviceType }) => {
  const [isLinkCopied, setLinkCopied] = useState(false);

  const handleLinkCopy = async () => {
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
    const origin = window.location.origin;
    const path = window.location.pathname;
    const pathList = path.split('/');
    const issueId = pathList[pathList.length - 1];
    const linkPrefix = `${origin}${
      import.meta.env.VITE_ROUTE_BASENAME
    }dashboard/browse/issues`;
    let link = `${linkPrefix}/${issueId}?serviceType=${serviceType}`;
    await copyToClipboard(link);
  };

  return (
    <Button
      startIcon={<Icon type="link" />}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '32px',
        verticalAlign: 'middle',
        lineHeight: 1,
        padding: '0 12px',
        whiteSpace: 'nowrap',
        borderRadius: '3px',
        fontSize: '14px',
        transition: 'all 0.1s',
        backgroundColor: '#fff',
        color: '#636363',
      }}
      onClick={handleLinkCopy}
      variant="text">
      {isLinkCopied
        ? intl.get('issue_details_button_link_copied')
        : intl.get('issue_details_button_copy_link')}
    </Button>
  );
};

CopyLinkButton.propTypes = propTypes;
export default CopyLinkButton;
